// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\nbody.touchscreen {\n  font-size: 1rem;\n  zoom: 1;\n}\n.app {\n  font-family: 'Montserrat', sans-serif;\n}\n.scroll-button {\n  display: none;\n}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
